import { Button, Flex, Input, Tooltip } from "@fluentui/react-northstar";
import { SurveyDTO } from "@teams/types/api";
import copy from "copy-to-clipboard";
import React, { useState } from "react";

import { useUserInfo } from "../actions/useUserInfo";
import { FetchError, isError } from "../services/ChannelApi";
import { surveyApi } from "../services/SurveyApi";
import { useTeamsContext } from "../state/TeamsContextProvider";
import { PollyIcon } from "./PollyIcon";

export const SurveyExternalLink: React.FC<{
  survey: SurveyDTO;
  primary?: boolean;
  trackingMethod: string;
  onChanged?: () => void;
}> = ({ survey, onChanged, primary, trackingMethod }) => {
  const [isSettingShortLink, setIsSettingShortLink] = useState<boolean>();
  const [shortCode, setShortCode] = useState<string | undefined>(survey.shortCodeUri);
  const [shortCodeError, setShortCodeError] = useState<string>();
  const [isLinkCopied, setIsLinkCopied] = useState<boolean>();
  const { teamsContext } = useTeamsContext();
  const { user } = useUserInfo();

  return (
    <Flex fill gap="gap.medium" vAlign="center">
      {shortCode && (
        <>
          <Input iconPosition="start" readOnly fluid value={shortCode} />
          <Tooltip
            onOpenChange={() => setIsLinkCopied(false)}
            position="above"
            align="start"
            content={!isLinkCopied ? "Copy external link to clipboard" : "Copied!"}
          >
            <Button
              icon={<PollyIcon icon="link-icon" />}
              styles={{ width: "175px" }}
              content={"Copy Link"}
              onClick={() => {
                copy(shortCode as string);
                setIsLinkCopied(true);
              }}
            />
          </Tooltip>
        </>
      )}
      {!shortCode && (
        <Flex.Item>
          <Flex column hAlign="center" gap="gap.medium">
            <Button
              primary={primary}
              loading={isSettingShortLink}
              disabled={isSettingShortLink}
              icon={<PollyIcon icon="link-icon" inheritColor />}
              text
              content="Create link"
              styles={{ marginBottom: "0px !important;", padding: "0px", color: "#008FF5" }}
              onClick={async () => {
                setIsSettingShortLink(true);
                const result = await surveyApi.addRecipient(
                  teamsContext,
                  survey.id!,
                  {
                    type: "web",
                    authMethod: "aad",
                    id: user.tenantId,
                  },
                  trackingMethod
                );
                setIsSettingShortLink(false);
                if (isError(result)) {
                  console.error(result);
                  const message =
                    result instanceof FetchError
                      ? (result.body?.message as string)
                      : result.message;

                  setShortCodeError(message);
                } else {
                  setShortCode(result.shortCode);
                  setShortCodeError(undefined);
                  if (onChanged) {
                    onChanged();
                  }
                }
              }}
            />

            <span hidden={!shortCodeError} style={{ color: "red" }}>
              Sorry, something went wrong while generating the link. {shortCodeError}
            </span>
          </Flex>
        </Flex.Item>
      )}
    </Flex>
  );
};
